module.exports = __webpack_public_path__ + "static/media/Public_31.bbb24db3.jpg";